import * as t from 'io-ts';
import { Template } from '../../pages/runtime-typechecker';

export const City = t.type({
  name: t.string,
  url: t.string,
});
export const StaticListIndexSingleChecker = t.type({
  status: t.string,
  citiesList: t.array(City),
  citiesCount: t.number,
  templateData: Template,
  pageOffset: t.number,
  pageSize: t.number,
  pushToCache: t.boolean,
  cacheKey: t.string,
  letter: t.string,
});
export type StaticListIndexSingleData = t.TypeOf<
  typeof StaticListIndexSingleChecker
>;
